export default "__VITE_ASSET__bqIhY4wg__"